module.exports = __webpack_public_path__ + "static/media/img_23.39e021f5.JPG";